// import React from 'react';
// import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from './ui/accordion';
// import { faq } from '../mockData';

// const FAQ = () => {
//   return (
//     <section id="faq" className="py-20 px-6 bg-gradient-to-b from-gray-50 to-white">
//       <div className="max-w-7xl mx-auto">
//         <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">
//           <div>
//             <h2 className="text-4xl md:text-5xl font-bold mb-6">{faq.title}</h2>
//             <p className="text-lg text-gray-600 mb-8">{faq.subtitle}</p>
//             <div className="rounded-3xl overflow-hidden shadow-2xl">
//               <img src={faq.image} alt="FAQ" className="w-full h-auto" />
//             </div>
//           </div>

//           <div>
//             <Accordion type="single" collapsible className="space-y-4">
//               {faq.items.map((item, index) => (
//                 <AccordionItem key={index} value={`item-${index}`} className="bg-white rounded-xl px-6 border border-gray-200">
//                   <AccordionTrigger className="text-left font-semibold hover:no-underline">
//                     <div className="flex items-center space-x-3">
//                       <span className="text-brand-blue-600 font-bold">{index + 1}</span>
//                       <span>{item.question}</span>
//                     </div>
//                   </AccordionTrigger>
//                   <AccordionContent className="text-gray-600 pl-8">
//                     {item.answer}
//                   </AccordionContent>
//                 </AccordionItem>
//               ))}
//             </Accordion>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default FAQ;


import React from 'react';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '@/components/ui/accordion';
import { faq } from '@/mockData';

const FAQ = () => {
  return (
    // DIUBAH: Dihapus 'bg-gradient-to-b from-gray-50 to-white'
    <section id="faq" className="py-20 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">
          <div>
            {/* DIUBAH: Teks judul diubah menjadi 'text-white' */}
            <h2 className="text-4xl md:text-5xl font-bold mb-6 text-white">{faq.title}</h2>
            {/* DIUBAH: Teks subjudul diubah menjadi 'text-gray-300' */}
            <p className="text-lg text-gray-300 mb-8">{faq.subtitle}</p>
            <div className="rounded-3xl overflow-hidden shadow-2xl">
              <img src={faq.image} alt="FAQ" className="w-full h-auto" />
            </div>
          </div>

          <div>
            <Accordion type="single" collapsible className="space-y-4">
              {faq.items.map((item, index) => (
                // DIUBAH: 'bg-white' dan 'border-gray-200' disesuaikan untuk dark mode
                <AccordionItem key={index} value={`item-${index}`} className="bg-black/30 backdrop-blur-lg rounded-xl px-6 border border-gray-700/50">
                  {/* Teks trigger akan otomatis putih karena 'text-foreground' */}
                  <AccordionTrigger className="text-left font-semibold hover:no-underline text-white">
                    <div className="flex items-center space-x-3">
                      {/* Badge ini sudah OK */}
                      <span className="text-brand-blue-400 font-bold">{index + 1}</span>
                      <span>{item.question}</span>
                    </div>
                  </AccordionTrigger>
                  {/* DIUBAH: Teks konten diubah menjadi 'text-gray-300' */}
                  <AccordionContent className="text-gray-300 pl-8">
                    {item.answer}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQ;